var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  default: () => password_default
});
var import_utils = __toModule(require("../../model/utils"));
const LOW_REGEX = /^.*(?=.{6,})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
const MEDIUM_REGEX = /^.*(?=.{8,})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
const STRONG_REGEX = /^.*(?=.{10,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
const securityLevels = {
  strong: {
    message: () => "password_strong",
    regexp: STRONG_REGEX
  },
  medium: {
    message: () => "password_medium",
    regexp: MEDIUM_REGEX
  },
  low: {
    message: () => "password_low",
    regexp: LOW_REGEX
  }
};
const message = () => {
  return "invalid_password";
};
const passwordLevel = (password) => {
  let level;
  for (const value of Object.values(securityLevels)) {
    if ((0, import_utils.regexTest)(password, value.regexp)) {
      level = value;
      break;
    }
  }
  return level ? level.message() : securityLevels.low.message();
};
const validate = (password) => {
  return (0, import_utils.regexTest)(password, securityLevels.low.regexp);
};
const PASSWORD = {
  validate,
  message,
  passwordLevel
};
var password_default = PASSWORD;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
